

export const getActionsByUserType = (userType, uid = null) => {
  const type = String(userType);

  // Admin users (type 8)
  if (type === "7") {
    return getAdminActions(uid);
  }

  // Distributor users (type 6)
  if (type === "6") {
    return getDistributorActions(uid);
  }

  // Default to logout only for unknown user types
  return [{ type: "logout" }];
};

export const getAdminActions = (uid) => {
return [
  {
    id: "dashboard",
    title: "Dashboard",
    subtitle: "Overview",
    icon: "fas fa-chart-line",
    iconClass: "icon-dashboard",
    path: "/distributor-dashboard",
  },
  {
    id: "distributors",
    title: "Distributors",
    subtitle: "Manage",
    icon: "fas fa-user-friends",
    iconClass: "icon-distributors",
    path: "/distributors",
  },
   {
      id: "customers",
      title: "Customers",
      subtitle: "Manage",
      icon: "fas fa-users",
      iconClass: "icon-customers",
      path: "/manage-customers",
    },
    {
      id: "capno-users",
      title: "CapnoGO Users",
      subtitle: "Browse",
      icon: "fas fa-address-card",
      iconClass: "icon-customers",
      path: "/admin/capnogo-users",
    },
    {
      id: "help-videos",
      title: "Help Videos",
      subtitle: "Manage",
      icon: "fas fa-video",
      iconClass: "icon-recordings",
      path: "/help-videos",
    },
    {
      id: "help-faqs",
      title: "FAQs",
      subtitle: "Manage",
      icon: "fas fa-question-circle",
      iconClass: "icon-support",
      path: "/help-faqs",
    },
    {
      id: "news-reports",
      title: "News Reports",
      subtitle: "Manage",
      icon: "fas fa-newspaper",
      iconClass: "icon-support",
      path: "/news-reports",
    },
    {
      id: "profile",
      title: "Profile",
      subtitle: "Edit",
      icon: "fas fa-user-cog",
      iconClass: "icon-profile",
      path: `/edit/profile/${uid}`,
      activeCheck: (pathname) => pathname.startsWith("/edit/distributor"),
    },
  // {
  //   id: "tech-support",
  //   title: "Tech Support",
  //   subtitle: "Manage",
  //   icon: "fas fa-headset",
  //   iconClass: "icon-support",
  //   path: "/tech-support",
  // },
  // {
  //   id: "announcements",
  //   title: "Announcements",
  //   subtitle: "Manage",
  //   icon: "fas fa-bullhorn",
  //   iconClass: "icon-announcements",
  //   path: "/announcements",
  // },
  // {
  //   id: "software-update",
  //   title: "Software Update",
  //   subtitle: "Manage",
  //   icon: "fas fa-cogs",
  //   iconClass: "icon-software",
  //   path: "/software-update",
  // },
  // {
  //   id: "recordings",
  //   title: "Recordings",
  //   subtitle: "Manage",
  //   icon: "fas fa-video",
  //   iconClass: "icon-recordings",
  //   path: "/recordings",
  // },
  {
    type: "logout",
  },
];
}

export const getDistributorActions = (uid) => {
  const actions = [
    {
      id: "dashboard",
      title: "Dashboard",
      subtitle: "Overview",
      icon: "fas fa-chart-line",
      iconClass: "icon-purchase",
      path: "/distributor-dashboard",
    },
    {
      id: "customers",
      title: "Customers",
      subtitle: "Manage",
      icon: "fas fa-users",
      iconClass: "icon-customers",
      path: "/manage-customers",
    },
    {
      id: "profile",
      title: "Profile",
      subtitle: "Edit",
      icon: "fas fa-user-cog",
      iconClass: "icon-profile",
      path: `/edit/profile/${uid}`,
      activeCheck: (pathname) => pathname.startsWith("/edit/profile"),
    },
    {
      id: "purchase",
      title: "Purchase",
      subtitle: "Modules & Accessories",
      icon: "fas fa-shopping-bag",
      iconClass: "icon-purchase",
      className: "purchase-card",
      onClick: "purchase",
    },
    {
      id: "api-guide",
      title: "Link Cart",
      subtitle: "Integration",
      icon: "fas fa-code",
      iconClass: "icon-api",
      path: "/api-integration",
    },
    {
      id: "widget",
      title: "Mini Cart",
      subtitle: "Configure",
      icon: "fas fa-shopping-cart",
      iconClass: "icon-cart",
      path: "/mini-cart",
    },
    {
      id: "help-videos",
      title: "Help Videos",
      subtitle: "Manage",
      icon: "fas fa-video",
      iconClass: "icon-recordings",
      path: "/help-videos",
    },
    {
      id: "help-faqs",
      title: "FAQs",
      subtitle: "Manage",
      icon: "fas fa-question-circle",
      iconClass: "icon-support",
      path: "/help-faqs",
    },
    {
      type: "logout",
    },
  ];
  return actions;
};
